{
    "defaultModel": "gpt-3.5-turbo",
    "defaultProvider": "openai",
    "defaultAuth": "api-key",
    "defaultBase": "",
    "defaultVersion": "",
    "defaultKey": "",
    "availableProviders": [
      { "value": "openai", "label": "OpenAI" },
      { "value": "anthropic", "label": "Anthropic (Claude)" },
      { "value": "google", "label": "Google (Gemini)" },
      { "value": "custom", "label": "Custom (e.g. Azure)" }
    ],
    "availableModels": {
      "openai": [
        {
          "value": "gpt-3.5-turbo",
          "label": "GPT-3.5-TURBO (Default ChatGPT)"
        },
        {
          "value": "gpt-3.5-turbo-0613",
          "label": "GPT-3.5-TURBO-0613"
        },
        {
          "value": "gpt-3.5-turbo-0301",
          "label": "GPT-3.5-TURBO-0301 (Legacy)"
        },
        {
          "value": "gpt-3.5-turbo-16k",
          "label": "GPT-3.5-TURBO-16K"
        },
        {
          "value": "gpt-3.5-turbo-16k-0613",
          "label": "GPT-3.5-TURBO-16K-0613"
        },
        {
          "value": "gpt-4",
          "label": "GPT-4 (Limited Beta)"
        },
        {
          "value": "gpt-4-0613",
          "label": "GPT-4-0613 (Limited Beta)"
        },
        {
          "value": "gpt-4-0314",
          "label": "GPT-4-0314 (Limited Beta, Legacy)"
        },
        {
          "value": "gpt-4-32k",
          "label": "GPT-4-32K (Limited Beta)"
        },
        {
          "value": "gpt-4-32k-0613",
          "label": "GPT-4-32K-0613 (Limited Beta)"
        },
        {
          "value": "gpt-4-32k-0314",
          "label": "GPT-4-32K-0314 (Limited Beta, Legacy)"
        },
        {
          "value": "gpt-4-1106-preview",
          "label": "GPT-4-1106-Preview"
        },
        {
          "value": "gpt-4-turbo",
          "label": "GPT-4 Turbo"
        },
        {
          "value": "gpt-4o",
          "label": "GPT-4 omni"
        }
      ],
      "anthropic": [
        {
          "value": "claude-3-7-sonnet-20250219",
          "label": "Claude 3.7 Sonnet"
        },
        {
          "value": "claude-3-7-sonnet-latest",
          "label": "Claude 3.7 Sonnet (Latest)"
        },
        {
          "value": "claude-3-5-haiku-20241022",
          "label": "Claude 3.5 Haiku"
        },
        {
          "value": "claude-3-5-haiku-latest",
          "label": "Claude 3.5 Haiku (Latest)"
        },
        {
          "value": "claude-3-5-sonnet-20241022",
          "label": "Claude 3.5 Sonnet v2"
        },
        {
          "value": "claude-3-5-sonnet-latest",
          "label": "Claude 3.5 Sonnet (Latest)"
        },
        {
          "value": "claude-3-5-sonnet-20240620",
          "label": "Claude 3.5 Sonnet"
        },
        {
          "value": "claude-3-opus-20240229",
          "label": "Claude 3 Opus"
        },
        {
          "value": "claude-3-opus-latest",
          "label": "Claude 3 Opus (Latest)"
        },
        {
          "value": "claude-3-sonnet-20240229",
          "label": "Claude 3 Sonnet"
        },
        {
          "value": "claude-3-haiku-20240307",
          "label": "Claude 3 Haiku"
        }
      ],
      "google": [
      ],
      "custom": [
      ]
    },
    "writingCharacters": [
      {
        "label": "Standup Comedian",
        "value": "A performer who entertains audiences by telling jokes and humorous stories."
      },
      {
        "label": "Life Coach",
        "value": "A professional who helps individuals identify and achieve their personal and professional goals."
      },
      {
        "label": "Career Counselor",
        "value": "A professional who helps individuals explore and choose careers, develop job search strategies, and improve job performance."
      },
      {
        "label": "Nutritionist",
        "value": "A health professional who specializes in the study of nutrition and its effects on the body."
      },
      {
        "label": "Product Manager",
        "value": "A professional who oversees the development and marketing of a company's products."
      },
      {
        "label": "Personal Trainer",
        "value": "A fitness professional who works with individuals to develop personalized exercise programs and improve their overall health and fitness."
      },
      {
        "label": "Life Hacker",
        "value": "A person who uses unconventional methods to solve problems and increase productivity in everyday life."
      },
      {
        "label": "Travel Advisor",
        "value": "A professional who helps individuals plan and book travel arrangements."
      },
      {
        "label": "Mindfulness Coach",
        "value": "A professional who helps individuals develop mindfulness practices to reduce stress and improve well-being."
      },
      {
        "label": "Financial Advisor",
        "value": "A professional who provides guidance and advice on financial planning, investment strategies, and retirement planning."
      },
      {
        "label": "Language Tutor",
        "value": "A teacher who helps individuals learn and improve their language skills."
      },
      {
        "label": "Travel Guide",
        "value": "A professional who leads tours and provides information about local attractions and culture."
      },
      {
        "label": "Marketing Expert",
        "value": "A professional who develops and implements marketing strategies to promote products and services."
      },
      {
        "label": "Software Developer",
        "value": "A professional who designs, develops, and maintains software applications and systems."
      },
      {
        "label": "Dating Coach",
        "value": "A professional who helps individuals improve their dating and relationship skills."
      },
      {
        "label": "DIY Expert",
        "value": "A person who is skilled at completing a wide range of do-it-yourself projects around the home."
      },
      {
        "label": "Journalist",
        "value": "A professional who investigates and reports on current events and news stories."
      },
      {
        "label": "Tech Writer",
        "value": "A professional who writes about technology and related topics for a variety of audiences."
      },
      {
        "label": "Professional Chef",
        "value": "A skilled culinary professional who prepares meals and manages kitchen operations."
      },
      {
        "label": "Professional Salesperson",
        "value": "A professional who sells products and services to businesses and consumers."
      },
      {
        "label": "Startup Tech Lawyer",
        "value": "A legal professional who specializes in providing legal advice and services to startup technology companies."
      },
      {
        "label": "Graphic Designer",
        "value": "A professional who designs visual materials such as logos, brochures, and websites."
      },
      {
        "label": "Academic Researcher",
        "value": "A professional who conducts research and produces scholarly work in a particular academic field."
      },
      {
        "label": "Customer Support Agent",
        "value": "A professional who provides assistance and support to customers who have questions or problems with a company's products or services."
      },
      {
        "label": "HR Consultant",
        "value": "A professional who provides guidance and advice to organizations on human resource management and strategy"
      }
    ],
    "writingTones": [
      "Assertive",
      "Authoritative",
      "Casual",
      "Confident",
      "Condescending",
      "Conversational",
      "Diplomatic",
      "Direct",
      "Eloquent",
      "Formal",
      "Friendly",
      "Humorous",
      "Informative",
      "Inspiring",
      "Intense",
      "Irritable",
      "Joking",
      "Polite",
      "Sarcastic",
      "Sincere",
      "Soothing",
      "Stern",
      "Sympathetic",
      "Tactful",
      "Witty"
    ],
    "writingStyles": [
      "Academic",
      "Analytical",
      "Argumentative",
      "Conversational",
      "Creative",
      "Critical",
      "Descriptive",
      "Explanatory",
      "Informative",
      "Instructive",
      "Investigative",
      "Journalistic",
      "Metaphorical",
      "Narrative",
      "Persuasive",
      "Poetic",
      "Satirical",
      "Technical"
    ],
    "writingFormats": [
      {
        "value": "Answer as concise as possible",
        "label": "Concise"
      },
      {
        "value": "Think step-by-step",
        "label": "Step-by-step"
      },
      {
        "value": "Answer in painstakingly detail",
        "label": "Extreme Detail"
      },
      {
        "value": "Explain like I'm five",
        "label": "Explain Like I'm Five"
      }
    ],
    "showDownloadLink": true,
    "allowDarkModeToggle": true,
    "allowSettingsModal": true,
    "allowDatabaseModal": true,
    "showTwitterLink": true,
    "showFeedbackLink": true
  }
